import React, { Component } from 'react'
import Link from '../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Play } from './icons'

class HeroBannerAppraisal extends Component {

  render() {

    let { backgroundImage, backgroundMobileImage, image, title, content, text, link} = this.props

    return (
      <section className='hero-banner-appraisal'>

        <img className='hero-banner-appraisal__bg hero-banner-appraisal__bg--mobile' src={backgroundMobileImage?.sourceUrl} alt={title} />

        <img className='hero-banner-appraisal__bg hero-banner-appraisal__bg--desktop' src={backgroundImage?.sourceUrl} alt={title} />

        <div className='hero-banner-appraisal__inner'>
          
            <div className='hero-banner-appraisal__content'>

              <div className='hero-banner-appraisal__details'>

                <div className='hero-banner-appraisal__heading'>

                  <h2 className='heading'>{ title }</h2>

                  <div className='copy' dangerouslySetInnerHTML={{ __html: content }} />

                </div>

                <div className='play-button'>

                  <Link to={link}>
                    { text }
                  </Link>

                </div>

              </div>

              <div className='hero-banner-appraisal__image'>

                { image?.sourceUrl && <img loading='lazy' src={image?.sourceUrl} alt={title} /> }

              </div>

            </div>

        </div>
      
      </section>
    )
  }
}

export default HeroBannerAppraisal
